import React, { useState, FC, useEffect } from 'react';
import Dropdown, { DropdownButtonTypes } from '../common/Dropdown';
import t from '../../translations';
import { CoeditPolicies, CoeditPolicy } from '../editors/editorsReducer';
import InfoIcon from './InfoIcon';

export enum CoeditApp {
    Word = 'word',
    Excel = 'excel',
    Powerpoint = 'powerpoint',
}
const coeditPolicyT = t.controlCenter.coeditPolicy;

const CoeditOptions = (collaborationAppsPrioritizationEnabled = false) => [
    { label: coeditPolicyT.policyOptions.ask, value: CoeditPolicies.Ask },
    {
        label: coeditPolicyT.policyOptions.alwaysCoedit,
        value: CoeditPolicies.AlwaysCoedit,
        disabled: !collaborationAppsPrioritizationEnabled,
    },
    { label: coeditPolicyT.policyOptions.neverCoedit, value: CoeditPolicies.NeverCoedit },
];

const coeditApps = [
    {
        label: 'Microsoft Word',
        value: CoeditApp.Word,
    },
    {
        label: 'Microsoft Excel',
        value: CoeditApp.Excel,
    },
    {
        label: 'Microsoft PowerPoint',
        value: CoeditApp.Powerpoint,
    },
];

interface CoeditingSettingsProps {
    onChange: (policy: CoeditPolicy) => void;
    collaborationAppsPrioritizationEnabled: boolean;
    coeditPolicy: CoeditPolicy;
}

const initialValues = {
    word: 'ask',
    excel: 'ask',
    powerpoint: 'ask',
    userCanOverwrite: true,
    arePoliciesEnabled: false,
};

const CoeditingSettings: FC<CoeditingSettingsProps> = ({
    onChange,
    coeditPolicy,
    collaborationAppsPrioritizationEnabled,
}) => {
    const [coeditOptions, setCoeditOptions] = useState(() => ({
        ...initialValues,
        ...coeditPolicy,
    }));

    const updateCoeditOptions = (key: string, value: string | boolean) => {
        setCoeditOptions((prevState) => ({ ...prevState, [key]: value }));
    };

    useEffect(() => {
        onChange(coeditOptions);
    }, [coeditOptions]);

    return (
        <div className="control-center-coedit">
            <h3>
                {coeditPolicyT.title}
                <span
                    className={`ast-app-editors sg-toggle ${coeditOptions.arePoliciesEnabled ? 'sg-toggle--on' : ''}`}
                    onClick={() => updateCoeditOptions('arePoliciesEnabled', !coeditOptions.arePoliciesEnabled)}
                />
            </h3>
            {coeditOptions.arePoliciesEnabled && (
                <>
                    <div className="control-center-coedit__info">
                        <InfoIcon /> {coeditPolicyT.info}
                    </div>

                    <div className="control-center-coedit__options">
                        {coeditApps.map((app) => (
                            <div key={app.value} className="control-center-coedit__option-block">
                                <div>{app.label}</div>
                                <Dropdown
                                    value={coeditOptions[app.value]}
                                    options={CoeditOptions(collaborationAppsPrioritizationEnabled)}
                                    onChange={(value) => updateCoeditOptions(app.value, value as CoeditPolicies)}
                                    label="Dropdown"
                                    buttonType={DropdownButtonTypes.Outlined}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="control-center-coedit__checkbox">
                        <span
                            className={`ast-app-editors sg-toggle ${
                                coeditOptions.userCanOverwrite ? 'sg-toggle--on' : ''
                            }`}
                            onClick={() => updateCoeditOptions('userCanOverwrite', !coeditOptions.userCanOverwrite)}
                        />
                        <span>{coeditPolicyT.allowOverride}</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default CoeditingSettings;
